module.exports = __webpack_public_path__ + "static/media/USA.6df21d69.jpg";